/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ZUSTAENDIGE_STELLE_SERVICE, ZustaendigeStelleService } from '@alfa-client/zustaendige-stelle-shared';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, inject } from '@angular/core';
import { Resource } from '@ngxp/rest';
import { InstantSearchResult } from '@ods/system';
import { Observable } from 'rxjs';

@Component({
  selector: 'alfa-search-zustaendige-stelle-form-container',
  templateUrl: './search-zustaendige-stelle-form-container.component.html',
  standalone: false,
})
export class SearchZustaendigeStelleFormContainerComponent<T extends Resource> implements OnInit {
  private readonly service = inject<ZustaendigeStelleService<T>>(ZUSTAENDIGE_STELLE_SERVICE);

  @Input() label: string;
  @Input() focusOnSearchField: boolean = false;
  @Output() searchResultSelected = new EventEmitter<T>();

  public searchResults$: Observable<InstantSearchResult<T>[]>;

  ngOnInit(): void {
    this.searchResults$ = this.service.getSearchResultList();
  }

  @HostListener('keydown', ['$event'])
  onKeyDownHandler(e: KeyboardEvent) {
    if (e.key === 'Enter' && this.isNotButtonElement(e.target as Element)) {
      e.preventDefault();
    }
  }

  public search(searchBy: string): void {
    this.service.search(searchBy);
  }

  public selectSearchResult(zustaendigeStelle: T): void {
    this.service.selectSearchResult(zustaendigeStelle);
    this.service.clearSearchResult();
    this.searchResultSelected.emit(zustaendigeStelle);
  }

  public clearSearchResult(): void {
    // todo: clear in  user search analog
    this.service.clearSearchResult();
  }

  public isNotButtonElement(e: Element): boolean {
    return e.tagName !== 'BUTTON';
  }
}
